/**
 * @generated SignedSource<<30c0754c244661fa5bacb4e6ec7ac6dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type checkoutPlansQuery$variables = {
  slug: string;
};
export type checkoutPlansQuery$data = {
  readonly scarfPlan: {
    readonly formattedPrice: string;
    readonly name: string;
    readonly rawPrice: number;
    readonly slug: string;
  };
};
export type checkoutPlansQuery = {
  response: checkoutPlansQuery$data;
  variables: checkoutPlansQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "slug",
        "variableName": "slug"
      }
    ],
    "concreteType": "ScarfPlan",
    "kind": "LinkedField",
    "name": "scarfPlan",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "formattedPrice",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rawPrice",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "checkoutPlansQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "checkoutPlansQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2bdd6d628222ea2066fc4de8dcd7f7a8",
    "id": null,
    "metadata": {},
    "name": "checkoutPlansQuery",
    "operationKind": "query",
    "text": "query checkoutPlansQuery(\n  $slug: String!\n) {\n  scarfPlan(slug: $slug) {\n    name\n    slug\n    formattedPrice\n    rawPrice\n  }\n}\n"
  }
};
})();

(node as any).hash = "4612e23458f487312d5d7ebffb35e1a7";

export default node;
